import tw from 'twin.macro'

const ErrorMessage = tw.div`text-sm text-red-500 font-bold`

export default ErrorMessage
